import socket from "../static/js/socket.js"
import UserActivity from "../static/js/user_activity.js"
UserActivity.init(socket, document.getElementById("user-activity"))
